module.exports = __webpack_public_path__ + "static/img/close.9d5ae96f.svg";